import { SchadenKICredentialsInput } from "./SchadenKICredentialsInput";
import { MultiadapterCredentialsInput } from "../multiadapter/MultiadapterCredentialsInput";
import { DatenadapterCredentialsInput } from "../datenadapter/DatenadapterCredentialsInput";
import { useTranslation } from "react-i18next";

export function SchadenKISettings() {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      {/* Sprachbot Multiadapter API Section */}
      <div className="space-y-4">
        <div>
          <h2 className="text-2xl font-bold">Sprachbot Multiadapter API</h2>
          <p className="text-muted-foreground mt-2">
            Zugangsdaten fuer die Sprachbot-Schnittstelle. Diese API wird verwendet fuer:
          </p>
          <ul className="text-muted-foreground mt-1 ml-4 list-disc text-sm">
            <li><strong>Wer ist mein Berater?</strong> - Authentifizierung via VSNR + PLZ (POST /api/v2/authorisierung)</li>
            <li><strong>Schadenstatus</strong> - Authentifizierung via Schadennummer + PLZ (POST /api/v3/authorisierung)</li>
          </ul>
          <p className="text-muted-foreground mt-2 text-sm">
            URL-Format: <code className="bg-muted px-1 rounded">https://[env]-multiadapter-sprachbot.[domain]/sprachbot</code>
          </p>
        </div>
        <MultiadapterCredentialsInput />
      </div>

      <hr className="border-t" />

      {/* Datenadapter API Section */}
      <div className="space-y-4">
        <div>
          <h2 className="text-2xl font-bold">Datenadapter API</h2>
          <p className="text-muted-foreground mt-2">
            Zugangsdaten fuer den Datenadapter (OASIS-Schnittstellen). Diese API wird verwendet fuer:
          </p>
          <ul className="text-muted-foreground mt-1 ml-4 list-disc text-sm">
            <li>Erweiterte Schadendaten-Abfragen (z.B. Personendaten, Adressdaten)</li>
            <li>Zukuenftige Datenabfragen die nicht ueber Multiadapter laufen</li>
          </ul>
          <p className="text-muted-foreground mt-2 text-sm">
            URL-Format: <code className="bg-muted px-1 rounded">https://[env]-multiadapter-daten.[domain]/daten</code>
          </p>
        </div>
        <DatenadapterCredentialsInput />
      </div>

      <hr className="border-t" />

      {/* SchadenKI API Section */}
      <div className="space-y-4">
        <div>
          <h2 className="text-2xl font-bold">{t("schadenKI.title")}</h2>
          <p className="text-muted-foreground mt-2">{t("schadenKI.description")}</p>
          <ul className="text-muted-foreground mt-1 ml-4 list-disc text-sm">
            <li>Schadenstatus-Details (pending/history)</li>
            <li>Status-URL Generierung fuer Kunden-Portal</li>
          </ul>
        </div>
        <SchadenKICredentialsInput />
      </div>
    </div>
  );
}
